<template>
  <b-col cols="12" class="p-0">
    <b-card :class="is_detail_network ? 'border-box-analytics' : ''">
      <b-card-header>
        <b-card-title>{{ $t('instagram.audienceInterest') }}</b-card-title>
      </b-card-header>
      <b-card-body class="text-start">
        <div class="interest-columns">
          <div
            class="d-flex align-items-center mb-1 justify-content-between"
            v-for="(item, index) in audienceData.interests"
            :key="index"
          >
            <b-card-text class="mb-0 mr-1">
              <b-img :class="`${getColor(item[1])} mr-1`" :src="getIconInterest(item[0])" />
              {{ $t(`instagram.${item[0]}`) }}:
            </b-card-text>
            <span>{{ round(item[1] * 100) }}%</span>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </b-col>
</template>
<script>
import { BCol, BCard, BCardHeader, BCardTitle, BCardBody, BCardText, BImg} from 'bootstrap-vue'
import { getIconInterest } from '@/libs/utils/icons'

export default {
  components: {
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BCardTitle,
    BCardText,
    BImg
  },
  props: {
    audienceData: {
      required: true
    },
    is_detail_network: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getColor () {
      return 'img-interest'
    },
    round (num) {
      return Math.round(num)
    },
    getInterest (interest) {
      return interest.replaceAll(' ', '')
    }
  },
  data () {
    return {
      getIconInterest,
    }
  },
}
</script>

<style scoped>
.interest-columns {
  column-count: 3;
  column-gap: 3rem;
}
@media (max-width: 900px) {
  .interest-columns {
    column-count: 2;
    column-gap: 3rem;
  }
}
@media (max-width: 640px) {
  .interest-columns {
    column-count: 1;
    column-gap: 4rem;
  }
}

.interest-columns > div {
  break-inside: avoid;
}
.img-interest {
  width: 25px;
  filter: brightness(0) saturate(100%) invert(8%) sepia(7%) saturate(300%) hue-rotate(180deg) brightness(95%) contrast(90%);
}
.button-center{
  text-align: center;
}
</style>